export const DE_VIDEO_URL = "https://vimeo.com/568956093/4df9cbdf76";
export const EN_VIDEO_URL = "https://vimeo.com/569323066";
export const ES_VIDEO_URL = "https://vimeo.com/568956203/34f838e400";
export const FR_VIDEO_URL = "https://vimeo.com/568956314/796dfc8882";
export const IT_VIDEO_URL = "https://vimeo.com/568956341/7043cf8989";
export const PL_VIDEO_URL = "https://vimeo.com/568956387/ecb2bcb792";
